import { Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Loader from '~/classes/Loader'

@Module({ name: 'loaderModule' })
export default class LoaderModule extends VuexModule {
  loaders: Loader<any>[] = []

  get isLoading (): (id: string) => boolean {
    return (id: string): boolean => this.loaders.some(x => x.id === id)
  }

  get isLoadingAny (): boolean {
    return this.loaders.length > 0
  }

  @Mutation
  addLoader (loader: Loader<any>) {
    this.loaders.push(loader)
  }

  @Mutation
  removeLoader (loader: Loader<any>) {
    this.loaders = this.loaders.filter(x => x !== loader)
  }
}
